export default __webpack_public_path__ + "static/media/1_WW6WR6-min.de58bd61.jpg";